import { createEnum } from './helpers'

export const MILLIS = {
  SECOND: 1000,
  MINUTE: 60000,
  HOUR: 3600000,
  DAY: 86400000,
  WEEK: 604800000,
  MONTH: 2629800000,
  YEAR: 31557600000,
} as const

// Idle session timeout, in minutes. Read-only users (no create/update/upload
// permissions) get an extended window (RLSE0117215); everyone else keeps the
// standard timeout.
export const SESSION_IDLE_TIMEOUT_MINUTES = 20
export const READ_ONLY_SESSION_IDLE_TIMEOUT_MINUTES = 60

/**
 * How long a Fuze app (core) user invitation stays valid, in hours (RLSE0122313). An invitation not
 * accepted inside this window is unusable and is deleted, and access has to be requested again.
 *
 * Only core invitations expire. CRT and Credit invitations carry no expiry, so `invites.expires_at`
 * is null for them, which is why the column has no database default: an invitation only gets an
 * expiry when the code that creates it decides the module warrants one.
 */
export const INVITE_VALID_HOURS_CORE = 120

export const MONTHS_IN_YEAR = 12
export const MONTH_KEYS = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec',
] as const
export type MonthKey = (typeof MONTH_KEYS)[number]

/**
 * CRT forecast-year codes: `CY` (current year) and `NY` (next year). This describes *which* forecast year
 * a view wants to see — it is a view/selection concept, not a point-in-time. Keep it here (shared) rather
 * than tied to any single feature's period utilities.
 */
export const YEAR_FLAG_VALUES = ['CY', 'NY'] as const
export const YEAR_FLAGS = createEnum(YEAR_FLAG_VALUES)
export type YearFlag = (typeof YEAR_FLAG_VALUES)[number]

/** Converts a month into a 0 - 11 index */
export function getMonthIndex(month: MonthKey): number {
  return MONTH_KEYS.indexOf(month)
}

/** Converts a month into a 01 - 12 index */
export function getFormattedMonthNumber(month: MonthKey): string {
  return String(MONTH_KEYS.indexOf(month) + 1).padStart(2, '0')
}
